module.exports = __webpack_public_path__ + "static/media/dashsentry-1.c04cdd53.jpg";